import { ERROR_TIMEOUT } from './constants';
export const formatValue = (val, desiredLen = 2) => {
    let retVal = val.toString();
    while (retVal.length < desiredLen) {
        retVal = '0' + retVal;
    }
    return retVal;
};
export const getCurrentTime = () => {
    const myCurrentTimestamp = new Date();
    return myCurrentTimestamp.getTime();
};
export const getTimeString = () => {
    const today = new Date();
    const hours = formatValue(today.getHours());
    const mins = formatValue(today.getMinutes());
    const secs = formatValue(today.getSeconds());
    const ms = formatValue(today.getMilliseconds(), 3);
    return `${hours}:${mins}:${secs}.${ms}`;
};
export const getDateTimeString = () => {
    const today = new Date();
    const hours = formatValue(today.getHours());
    const mins = formatValue(today.getMinutes());
    const secs = formatValue(today.getSeconds());
    const day = formatValue(today.getDate());
    const month = formatValue(today.getMonth() + 1);
    const year = today.getFullYear();
    return `${month}/${day}/${year} ${hours}:${mins}:${secs}`;
};
export const isString = (object) => {
    return typeof object === 'string';
};
export const compareIgnoreCase = (stringValue, matches) => {
    if (isString(stringValue) && isString(matches)) {
        return stringValue.localeCompare(matches, undefined, {
            sensitivity: 'accent'
        }) === 0;
    }
    else if (!isEmpty(matches) && matches.constructor === Array) {
        let arrayResult = false;
        for (let count = 0; count < matches.length; count++) {
            const localResult = compareIgnoreCase(stringValue, matches[count]);
            if (localResult) {
                arrayResult = true;
                break;
            }
        }
        return arrayResult;
    }
    else {
        return stringValue !== matches;
    }
};
export const isFunction = (pointer) => {
    return typeof pointer === 'function';
};
export const isEmpty = (object) => {
    if (object === undefined || object === null || object === '' || object === 0 || object === false) {
        return true;
    }
    return false;
};
const whiteSpaceValidationEx = /^\s*$/;
const nativeCodeValidationEx = /\{\s*\[native code\]\s*\}/;
export const isWhitespace = (s) => {
    return whiteSpaceValidationEx.test(s);
};
export const isMethodNative = (pointer) => {
    const result = isFunction(pointer) ? (nativeCodeValidationEx).test('' + pointer) : false;
    return result;
};
export const getViewPort = () => {
    var _a;
    let viewPortWidth = 0;
    let viewPortHeight = 0;
    if (typeof window.innerWidth !== 'undefined') {
        viewPortWidth = window.innerWidth;
        viewPortHeight = window.innerHeight;
    }
    else if (!isEmpty((_a = document.documentElement) === null || _a === void 0 ? void 0 : _a.clientWidth)) {
        viewPortWidth = document.documentElement.clientWidth;
        viewPortHeight = document.documentElement.clientHeight;
    }
    else {
        viewPortWidth = document.getElementsByTagName('body')[0].clientWidth;
        viewPortHeight = document.getElementsByTagName('body')[0].clientHeight;
    }
    return {
        width: viewPortWidth,
        height: viewPortHeight
    };
};
export const getWinHeight = () => {
    return window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
};
export const getWinWidth = () => {
    return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
};
export const getElementAs = (id) => {
    return document.getElementById(id);
};
export const setClass = (element, className) => {
    const elem = isString(element) ? getElementAs(element) : element;
    if (elem !== null) {
        elem.className = className;
    }
};
export const setCss = (elem, attrs) => {
    const element = isString(elem) ? getElementAs(elem) : elem;
    if (element !== null) {
        Object.keys(attrs).forEach(key => {
            element.style.setProperty(key, attrs[key]);
        });
    }
};
export const hideElement = (elem) => {
    setCss(elem, { display: 'none' });
};
export const showElement = (elem) => {
    setCss(elem, { display: 'block' });
};
export const fireEvent = (element, event) => {
    try {
        let evt = null;
        if (isFunction(document.createEvent)) {
            evt = document.createEvent('MouseEvent');
            evt.initMouseEvent(event, true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
        }
        else {
            evt = new MouseEvent(event, {
                button: 0,
                bubbles: true,
                view: window,
                cancelable: true
            });
        }
        return !element.dispatchEvent(evt);
    }
    catch (e) {
        return false;
    }
};
export const stopEvent = (e) => {
    const evt = !isEmpty(e) ? e : window.event;
    if (!isEmpty(evt)) {
        evt.returnValue = false;
        evt.cancelBubble = true;
        if (isFunction(evt.stopPropagation)) {
            evt.stopPropagation();
        }
        if (isFunction(evt.preventDefault)) {
            evt.preventDefault();
        }
    }
};
export const displayText = (label, labelText) => {
    const element = isString(label) ? getElementAs(label) : label;
    if (element !== null) {
        element.innerHTML = labelText !== null && labelText !== void 0 ? labelText : '';
    }
};
export const preloadImageBySource = (source) => {
    const image = new Image();
    image.src = source;
};
export const preloadImage = (elem) => {
    return preloadImageBySource(elem.src);
};
let encoder = null;
export const htmlEncode = (text) => {
    if (encoder === null) {
        encoder = document.createElement('span');
    }
    encoder.innerText = text;
    return encoder.innerHTML;
};
export const htmlDecode = (text) => {
    if (encoder === null) {
        encoder = document.createElement('span');
    }
    encoder.innerHTML = text;
    return encoder.innerText;
};
export const randomInRange = (from, to) => Math.floor(Math.random() * (to - from + 1) + from);
export const getTopFrame = () => {
    try {
        try {
            const topdomain = top === null || top === void 0 ? void 0 : top.location.hostname;
            if (isString(topdomain)) {
                return top;
            }
        }
        catch (e) { }
        let curWindow = self;
        let windowCnt = 0;
        while (curWindow != curWindow.parent && windowCnt++ < 32) {
            try {
                const parentdomain = curWindow.parent.location.hostname;
                if (isString(parentdomain)) {
                    curWindow = curWindow.parent;
                    continue;
                }
            }
            catch (e) { }
            return curWindow;
        }
        return curWindow;
    }
    catch (e) {
        return self;
    }
};
export const doesObjectExist = (objectName) => {
    if (isString(objectName)) {
        const objectNameParts = objectName.split('.');
        if (objectNameParts.length > 0) {
            let conditionFullfilled = true;
            let context = window;
            for (let i = 0; i < objectNameParts.length; i++) {
                if (context !== null &&
                    (objectNameParts[i] in context &&
                        typeof (context[objectNameParts[i]]) !== 'undefined')) {
                    context = context[objectNameParts[i]];
                }
                else {
                    conditionFullfilled = false;
                    break;
                }
            }
            return conditionFullfilled;
        }
    }
    return false;
};
export const awaitObject = (objectName, timeout) => {
    return new Promise((resolve, reject) => {
        if (doesObjectExist(objectName)) {
            resolve();
            return;
        }
        const startTime = getCurrentTime();
        const objectWaitInterval = setInterval(() => {
            if (doesObjectExist(objectName)) {
                clearInterval(objectWaitInterval);
                resolve();
                return;
            }
            else if (timeout !== undefined) {
                const currentTime = getCurrentTime();
                if (currentTime - startTime > timeout) {
                    clearInterval(objectWaitInterval);
                    reject(new Error(ERROR_TIMEOUT));
                    return;
                }
            }
        }, 111);
    });
};
